import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent {
  @Input() progress: {
    info?: number;
    success?: number;
    error?: number;
  };
  @Input() totalLength: number;

  constructor() {}
}
